export default __webpack_public_path__ + "static/media/fa-regular-400.f4f60ace.svg";